import { Link } from "react-router-dom";
import { ArrowUpRight, Sparkle } from "lucide-react";
import { DOLLY_QUOTES } from "../data/site";
import { useEtsyListings, isDollyListing, tributeItem } from "../data/etsy";
import { ProductCard } from "./ProductCard";
import { Reveal } from "./motion";

export const DollySection = () => {
  const listings = useEtsyListings();
  const dollyItems = listings.filter(isDollyListing).map(tributeItem).slice(0, 4);

  return (
    <section data-testid="dolly-section" className="border-t border-cream/10 bg-navy text-cream">
      <div className="mx-auto max-w-[1600px] px-6 py-28 md:px-12 md:py-36">
        <div className="grid gap-14 lg:grid-cols-12 lg:gap-20">
          <div className="lg:col-span-5">
            <Reveal>
              <p className="flex items-center gap-3 text-[11px] font-medium uppercase tracking-[0.35em] text-cream/50">
                <Sparkle className="h-4 w-4 fill-mustard text-mustard" />
                In loving memory · 1946 — 2026
              </p>
              <h2 className="mt-8 font-playfair text-5xl leading-[0.92] tracking-tight md:text-7xl">
                Dolly
                <br />
                Parton
              </h2>
              <p className="mt-8 -rotate-2 font-caveat text-3xl font-semibold text-mustard md:text-4xl">
                thank you for the light
              </p>
              <Link
                to="/tribute"
                data-testid="dolly-tribute-link"
                className="group mt-10 inline-flex items-center gap-3 rounded-full bg-cream px-7 py-3.5 text-xs font-medium uppercase tracking-[0.25em] text-navy transition-transform duration-300 hover:scale-95"
              >
                Visit the tribute
                <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
              </Link>
            </Reveal>
          </div>
          <div className="lg:col-span-7">
            {DOLLY_QUOTES.slice(0, 3).map((q, i) => (
              <Reveal key={q} delay={Math.min(i * 0.06, 0.2)}>
                <figure
                  data-testid={`dolly-quote-${i + 1}`}
                  className="group border-t border-cream/15 py-8 last:border-b md:py-9"
                >
                  <blockquote className="font-playfair text-2xl italic leading-snug tracking-tight text-cream transition-transform duration-500 group-hover:translate-x-3 md:text-3xl">
                    “{q}”
                  </blockquote>
                  <figcaption className="mt-4 text-[10px] uppercase tracking-[0.3em] text-mustard/80">
                    Dolly Parton
                  </figcaption>
                </figure>
              </Reveal>
            ))}
          </div>
        </div>

        {dollyItems.length > 0 && (
          <div className="mt-20 border-t border-cream/15 pt-14">
            <Reveal>
              <div className="flex flex-wrap items-end justify-between gap-4">
                <p className="text-[11px] font-medium uppercase tracking-[0.3em] text-cream/50">
                  Pieces carrying her words — live on Etsy now
                </p>
                <Link
                  to="/tribute"
                  data-testid="dolly-view-all-link"
                  className="group flex items-center gap-2 text-xs font-medium uppercase tracking-[0.25em] text-cream/70 transition-colors duration-300 hover:text-cream"
                >
                  View the full tribute
                  <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
                </Link>
              </div>
            </Reveal>
            <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
              {dollyItems.map((item, i) => (
                <Reveal key={`${item.name}-${i}`} delay={Math.min(i * 0.06, 0.2)} className="h-full">
                  <ProductCard item={item} setId="dolly-home" />
                </Reveal>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};
